module.exports = __webpack_public_path__ + "static/media/7.7daff28a.png";